import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=268f3f8a&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=ts"
export * from "./orderDetail.vue?vue&type=script&lang=ts"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=268f3f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268f3f8a",
  null
  
)

export default component.exports